/**
 * /execution/friction — read-only FrictionLogDashboard (Phase 2a) wrapped.
 * Only writer reachable here is `acknowledgeFriction()` — whitelisted.
 */
import { CockpitPage } from "@/components/cockpit/CockpitPage";
import { FrictionLogDashboard } from "@/components/observability/FrictionLogDashboard";
import { useRole } from "@/data/RoleContext";
import { canAccessExecutionDomain } from "@/data/executionDomain";

export default function ExecutionFrictionPage({ embedded = false }: { embedded?: boolean } = {}) {
  const { role } = useRole();
  if (!canAccessExecutionDomain(role)) return null;
  if (embedded) return <FrictionLogDashboard />;
  return (
    <CockpitPage title="Friction Review" maxWidth="7xl">
      <FrictionLogDashboard />
    </CockpitPage>
  );
}
